import { render, staticRenderFns } from "./AdminPaymentReceiptFilters.vue?vue&type=template&id=b1a221b6"
import script from "./AdminPaymentReceiptFilters.vue?vue&type=script&lang=js"
export * from "./AdminPaymentReceiptFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports